export default "__VITE_ASSET__LeKvWNoF__"